import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "route-page" }
const _hoisted_2 = { class: "route-page__content" }
const _hoisted_3 = {
  key: 0,
  class: "route-page__heading"
}
const _hoisted_4 = {
  key: 1,
  class: "route-page__price"
}
const _hoisted_5 = {
  key: 2,
  class: "route-page__preamble"
}
const _hoisted_6 = {
  key: 0,
  class: "route-page__image"
}
const _hoisted_7 = ["src", "srcset", "sizes", "alt"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "route-page__content"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["innerHTML"]

import RouteTable from "@features/Pages/RoutePage/Components/RouteTable/RouteTable.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoutePage',
  props: {
    routePage: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (__props.routePage.title)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.routePage.title), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (__props.routePage.price)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.routePage.price), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (__props.routePage.introduction)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.routePage.introduction), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (__props.routePage.imageUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", {
            src: __props.routePage.imageUrl,
            srcset: __props.routePage.imageSrcSet || undefined,
            sizes: __props.routePage.imageSizes || undefined,
            alt: __props.routePage.imageAltText
          }, null, 8 /* PROPS */, _hoisted_7)
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.routePage.upperBlocks, (block, index) => {
      return (_openBlock(), _createElementBlock("section", {
        key: `upper-${block.blockType}-${index}`,
        class: "route-page__content"
      }, [
        (block.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(block.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (block.text)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: block.text
            }, null, 8 /* PROPS */, _hoisted_9))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    (__props.routePage.ticket)
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          _createVNode(RouteTable, {
            ticket: __props.routePage.ticket
          }, null, 8 /* PROPS */, ["ticket"])
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.routePage.lowerBlocks, (block, index) => {
      return (_openBlock(), _createElementBlock("section", {
        key: `lower-${block.blockType}-${index}`,
        class: "route-page__content"
      }, [
        (block.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_11, _toDisplayString(block.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (block.text)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: block.text
            }, null, 8 /* PROPS */, _hoisted_12))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})